import StoreStore from './StoreStore'

export default StoreStore
